module.exports = "<div class=\"element-bg-img\"><img [src]=\"url\" alt=\"\" class=\"img-responsive\"></div>"